import { ImageProps } from 'next/image'
import { makeRootUrlsAbsolute } from 'src/utils/FormatUtils'

import APP from '../../configuration/app'
import { NavMenuProps } from '../../components/NavMenu'
import ActionButton from '../../components/ActionButton'
import { colors } from '../../theme'

export type KalioFirstLevelItem = {
  name: string
  href: string
  subItems: KaliopSecondLevelItem[]
  PUSH: Push
}

type KaliopSecondLevelItem = {
  name: string
  href: string
  items?: KaliopThirdLevelItem[]
}

type KaliopThirdLevelItem = Link

type Link = {
  name: string
  href: string
}

type Push =
  | {
      uptitle: string
      title: string
      CTA: Link
      bgcolor: string
      Media: string
    }
  | []
  | never[] //Json sends empty array if empty...

export const KaliopMenuTransformer = (
  menu: KalioFirstLevelItem[]
): NavMenuProps => ({
  links: menu.map((m: KalioFirstLevelItem, index: number) => ({
    isSeparated: menu?.length - 2 === index,
    link: {
      text: m?.name ?? '',
      href: makeRootUrlsAbsolute(m?.href ?? ''),
    },
    ...(m?.subItems?.length > 0
      ? {
          levelTwo: m?.subItems?.map((t: KaliopSecondLevelItem) => ({
            link: {
              text: t?.name ?? '',
              href: makeRootUrlsAbsolute(t?.href ?? ''),
            },
            ...(t?.items && t?.items?.length > 0
              ? {
                  levelThree: t?.items?.map((l: KaliopThirdLevelItem) => ({
                    link: {
                      text: l?.name ?? '',
                      href: makeRootUrlsAbsolute(l?.href ?? ''),
                    },
                  })),
                }
              : {}),
          })),
        }
      : {}),
    ...(m?.PUSH && !Array.isArray(m?.PUSH)
      ? {
          push: {
            color:
              m?.PUSH?.bgcolor === 'green'
                ? colors.greenEmerald
                : m?.PUSH?.bgcolor === 'orange'
                ? colors.orangeFire
                : colors.greenEmerald,
            ...(m?.PUSH?.Media
              ? {
                  imageProps: {
                    src: m?.PUSH?.Media ?? '',
                    alt: m?.PUSH?.title,
                    objectFit: 'cover',
                    layout: 'fill',
                  } as ImageProps,
                }
              : {}),
            firstHighlightText: m?.PUSH?.uptitle,
            secondHighlightText: m?.PUSH?.title,
            ctaHref: m?.PUSH?.CTA?.href,
            buttons: (
              <>
                <ActionButton
                  text={m?.PUSH?.CTA?.name ?? ''}
                  variantType="link"
                  variantColorScheme="black"
                  variantColor={colors.greenApple}
                  actionProps={{
                    href: m?.PUSH?.CTA?.href ?? '',
                    target: '_self',
                  }}
                />
              </>
            ),
          },
        }
      : {}),
  })),
  ...(menu.find((m) => m.name === APP.SPECIAL_MENU_LABEL)?.subItems && {
    push: menu
      .find((m) => m.name === APP.SPECIAL_MENU_LABEL)
      ?.subItems?.map((m) => ({
        color: '',
        firstHighlightText: m?.name ?? '',
        secondHighlightText: m?.name ?? '',
        ctaHref: m?.href,
        buttons: (
          <>
            <ActionButton
              text={m?.name ?? ''}
              variantType="link"
              variantColorScheme="black"
              variantColor={colors.greenApple}
              actionProps={{
                href: m?.href ?? '',
                target: '_self',
              }}
            />
          </>
        ),
      })),
  }),
})
